import script from "./ColumnStatsPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnStatsPopover.vue?vue&type=script&setup=true&lang=js"

import "./ColumnStatsPopover.vue?vue&type=style&index=0&id=0f80992f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f80992f"]])

export default __exports__